import React from 'react';
import { Eye, Scales, TrendUp } from '@phosphor-icons/react';

const propositions = [
  {
    icon: <Eye size={32} weight="duotone" className="text-[#0052FF]" />,
    title: 'Outstanding Visibility',
    description: 'Real-time, comprehensive dashboards for cloud health and AI operations. Monitor every layer of your infrastructure with precision.',
  },
  {
    icon: <Scales size={32} weight="duotone" className="text-[#0052FF]" />,
    title: 'Precise Transparency',
    description: 'Granular tracking for FinOps, resource utilization, and cost optimization. Know exactly where every dollar goes across your cloud estate.',
  },
  {
    icon: <TrendUp size={32} weight="duotone" className="text-[#0052FF]" />,
    title: 'Limitless Scalability',
    description: 'Solutions that grow seamlessly from agile startups to global enterprises. Architecture designed for infinite horizontal scaling.',
  },
];

export default function ValuePropositions() {
  return (
    <section className="py-20 md:py-32 bg-white" data-testid="value-propositions-section">
      <div className="w-full px-6 md:px-10 lg:px-16 xl:px-24">
        {/* Section header */}
        <div className="mb-16 text-center">
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#0052FF] mb-3">
            The AIAURORA Advantage
          </p>
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl tracking-tight font-bold text-[#0B132B]"
            style={{ fontFamily: 'Chivo, sans-serif' }}
          >
            Enterprise-Grade Cloud Intelligence
          </h2>
        </div>

        {/* 3-column grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {propositions.map((item) => (
            <div
              key={item.title}
              className="p-8 border border-slate-200 hover:border-[#0052FF]/30 transition-colors duration-200 group text-center"
              data-testid={`value-prop-${item.title.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <div className="mb-5 p-3 inline-flex mx-auto bg-[#F8FAFC] border border-slate-100 group-hover:border-[#0052FF]/20 transition-colors duration-200">
                {item.icon}
              </div>
              <h3
                className="text-xl sm:text-2xl tracking-tight font-semibold text-[#0B132B] mb-3"
                style={{ fontFamily: 'Chivo, sans-serif' }}
              >
                {item.title}
              </h3>
              <p className="text-base leading-relaxed text-[#475569]" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
